import { createCacheStore } from '@lib/utils/cache';
import { DepartmentService } from '@api/DepartmentService';

/** Cached DepartmentService.getPositions(departmentId) reads. */
export const positionsCache = createCacheStore(
    'department/positions',
    DepartmentService.getPositions,
);

/** Drops the cached positions of a department (after position mutations). */
export const invalidatePositions = (departmentId: string): void => {
    positionsCache.invalidate(departmentId);
};

/** Drops all cached position data (department switch, full clears). */
export const invalidatePositionData = (): void => {
    positionsCache.invalidateAll();
};
